import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Typography } from "@mui/material";
import { useSnackbar } from "notistack";
import { useState } from "react";
import useWidth from "../../../../hooks/useWidth";
import EmailAuthenticationService from "../../../../services/api/email-authentication";
import { ThreeDots } from 'react-loader-spinner';



function RemoveCancelConfirmationDialogComponent (props){

    const {headerTitle, contentDescription, openRemoveConfirmationDialog, handleCloseRemoveConfirmationDialog, authenticationDetails, projectId} = props
    const breakpoints = useWidth()
    const [error, setError] = useState(null);
    const { enqueueSnackbar } = useSnackbar();
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);

    console.log("authenticationDetails aaa", authenticationDetails);

    const handleRemoveEmail = (id) => {
        setLoading(true);
        EmailAuthenticationService.removeEmailSender(id).then((res)=>{
            if(res.data.success){
                setLoading(false);
                enqueueSnackbar("Email has been removed.", { 
                    variant: 'success',
                    autoHideDuration: 3000
                }); 
                handleCloseRemoveConfirmationDialog()
                // window.location.reload();
                props.getListEmailSender(projectId, page);
            }
        }).catch((err)=>{
            setLoading(false);
            setError(err.response.statusText);
            enqueueSnackbar(err.response.data.error, { 
                variant: 'error',
                autoHideDuration: 3000
            }); 
        })
    }

    return(
        <Dialog open={openRemoveConfirmationDialog} onClose={handleCloseRemoveConfirmationDialog} maxWidth={'sm'} fullWidth={'sm'} PaperProps={{ style: {boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px', borderRadius: 5, margin: 'auto'}}}>
            <DialogTitle>
                {headerTitle}
            </DialogTitle>

            <Divider/>

            <DialogContent sx={{padding: breakpoints == 'xs' || breakpoints == 'sm' ? 3 : 6, paddingTop: 2}}>
                <Typography sx={{textAlign:'center', fontSize: 14}}>
                    {contentDescription}
                </Typography>
            </DialogContent>

            <DialogActions sx={{padding: breakpoints == 'xs' || breakpoints == 'sm' ? 3 : 6, paddingTop: 0, paddingBottom: 3}}>
                <Button onClick={handleCloseRemoveConfirmationDialog} sx={{color: 'black', textTransform: 'none'}}>Cancel</Button>
                <Button variant="contained" 
                    onClick={()=> handleRemoveEmail(authenticationDetails?.id)}
                    startIcon={loading ? <ThreeDots height="20" width="20" radius="9" color="#ffff" ariaLabel="three-dots-loading" visible={true} /> : null}
                >
                    { loading ? 'Removing' : 'Confirm' }
                </Button>
            </DialogActions>
        </Dialog>
    )
}
export default RemoveCancelConfirmationDialogComponent